import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=a766637c&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=a766637c&prod&scoped=true&lang=scss"
import style1 from "./Index.vue?vue&type=style&index=1&id=a766637c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a766637c",
  null
  
)

export default component.exports